<template>
  <div v-if="$template" class="relative">
    <div class="end-container">
      <p
        v-if="$store.isCancel"
        class="font-bold w-fit m-4 mx-auto text-normal"
        v-html="tagText($template.cancel_order)"
      ></p>
      <p
        v-else
        class="font-bold w-fit m-4 mx-auto text-normal"
        v-html="tagText($template.valid_order)"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EndView',
  emits: ['openModal', 'openNotification'],
  data: () => ({
    error: ''
  }),
  beforeMount() {
    if (this.$template) {
      document.body.style.backgroundColor =
        this.$template.page_background_color
    }
  },
}
</script>

<style scoped>
.end-container {
  background-color: v-bind(
    "!$template ? '' : $store.isCancel ? $template.cancel_order_background_color : $template.valid_order_background_color"
  );
}
</style>
